module.exports = __webpack_public_path__ + "img/love2.e04be060.png";